module.exports = __webpack_public_path__ + "img/107-72654c.png";